import React, { Component } from "react";
import logo from "./logo.svg";
import "./App.css";
import { RedocStandalone } from "redoc";
import { BrowserRouter, Route, Switch, withRouter } from "react-router-dom";

const basePath = () => {
  const path = window.location.pathname;
  return path.substring(0, path.lastIndexOf("/"));
};

const routeTo = destination => basePath() + "/" + destination;

const PartnerSignupAPI = () => (
  <RedocStandalone specUrl={basePath() + "/Partner_Signup_API.yml"} />
);

const APIContract = () => (
  <RedocStandalone specUrl={basePath() + "/API_Contract.yml"} />
);

const QualificationList = () => (
  <RedocStandalone specUrl={basePath() + "/Qualification_list.yml"} />
);

const NavButton = withRouter(({ destination, history, label, location }) => (
  <button
    className={
      location.pathname.endsWith(`/${destination}`)
        ? "nav-button active"
        : "nav-button"
    }
    type="button"
    onClick={() => history.replace(routeTo(destination))}
  >
    {label}
  </button>
));

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <header className="App-header">
            <img src={logo} className="App-logo" alt="logo" />
            <h1 className="App-title">
              Welcome to the FocusVision Sample Partner Hub
            </h1>
            <p>
              <NavButton destination="" label="API Contract" />
              <NavButton destination="quals" label="Qualification List" />

              <NavButton destination="signup" label="Partner Signup API" />
            </p>
          </header>

          <Switch>
            <Route path={routeTo("")} exact component={APIContract} />
            <Route path={routeTo("signup")} component={PartnerSignupAPI} />
            <Route path={routeTo("quals")} component={QualificationList} />
          </Switch>

          <p className="App-intro" />
        </div>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js